module.exports = __webpack_public_path__ + "static/media/16.00343481.webp";